var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'urgent': _vm.seconds <= 3600 }},[_vm._v("\n    "+_vm._s(_vm.displayTime)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }